import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { ConfigureOrderBookingEmailPresentation } from './configure-order-booking-email.presentation';
import { ConfigureOrderBookingEmailVM } from './order-booking-emails-list.viewmodel';

interface IProps {
    vm: ConfigureOrderBookingEmailVM;
}

const ConfigureOrderBookingEmailContainer = withViewModel(
    ConfigureOrderBookingEmailPresentation,
    (props: IProps) => props.vm,
    () => []
);

export { ConfigureOrderBookingEmailContainer as ConfigureOrderBookingEmail };
